import { render, staticRenderFns } from "./healthCard.vue?vue&type=template&id=1d01496b&scoped=true&"
import script from "./healthCard.vue?vue&type=script&lang=js&"
export * from "./healthCard.vue?vue&type=script&lang=js&"
import style0 from "./healthCard.vue?vue&type=style&index=0&id=1d01496b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d01496b",
  null
  
)

export default component.exports